// extracted by mini-css-extract-plugin
export default {"colorpass":"#36b15b","colorfail":"#cc0024","colorcancelled":"#ccc","colorerror":"#ffa600","ChartWrapper":"TestCaseResultChart_ChartWrapper__8cyXk"};